// internal
import { axios, storage, def, handleError } from './internal';

function MfaSetup(onSuccess) {
    axios
        .post('/api/mfa_setup')
        .then((res) => {
            onSuccess?.(res.data.data);
        })
        .catch((err) => {
            const { status, data } = err.response || {};
            switch (status) {
                case def.StatusCodes.BAD_REQUEST: // 400
                    switch (data?.code) {
                        case def.ErrorCode.MFA_ALREADY_ENABLED:
                            storage.transience.setState(
                                'internal.error',
                                'Two-factor authentication is already enabled.',
                            );
                            break;
                        default:
                            handleError(err);
                            break;
                    }
                    break;
                default:
                    handleError(err);
                    break;
            }
        });
}

export { MfaSetup };
